import logo from './logo.svg';
import './App.css';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './User/Home';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'react-multi-carousel/lib/styles.css';
import Product from './User/Product';
import List from './User/List';
import SalonHome from './Shop/Home';
import Gallery from './Shop/Gallery';
import Dashboard from './Admin/Dashboard'
import Client from './Admin/Clients';
import Service from './User/Service';
import Services from './Shop/Services';
import Options from './Shop/Options';
import Team from './Admin/Team';
import User from './Admin/User';
import Pages from './Admin/Pages';
import Signin from './Admin/Signin';
import Support from './Support';
import ContactRequests from './Admin/ContactRequests';
import Settings from './Admin/Settings';
import Test from './User/Test';
import SalonTeam from './Shop/Team';
import AddMembers from './Shop/AddMember';
import NavbarLayot from './User/NavbarLayout';
import Navbar from './User/Navbar';
import Categoties from './Admin/Categories';
import Search from './User/Search';
import SignUp from './User/SignUp';
import ScrollToTop from './User/components/ScrollToTop';
import Reviews from './Shop/Reviews';
import BusinessDetails from './Shop/BusinessDetails';
import { SalonContextProvider } from './Shop/context/SalonContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Typography } from '@mui/material';
// import { Dashboard } from '@mui/icons-material';
// import Homee from './Shop/Shome/';

function App() {

  // const [data, setdata] = useState();
  // var url = 'http://localhost:1000/'
  // function fetchData() {

  //   axios.post(url + 'getUsers').then((succ) => {
  //     console.log(succ.data);
  //   })

  // }
  // useEffect(() => {
  //   fetchData();
  // }, [])

  const [phoneNumber, setPhoneNumber] = useState("");
  const [showNavbar, setShowNavbar] = useState(false);
  const { loading } = useAuth();

  if (loading) {
    return <Typography>Loading</Typography>;
  }

  return (
    <>

      <SalonContextProvider>
          <Router>
            <ScrollToTop />
            <Routes>
              <Route element={
                <Navbar />
              }>
                <Route path='/Barber/:shopSlug' element={<Product />} />
              </Route>
              <Route path='/' element={<Home />} />
              <Route path='/search' element={<Search />} />
              <Route path='/List' element={<List />} />
              <Route path='/SignUp' element={<SignUp />} />
              <Route path='/Salon/:shopSlug/Dashboard' element={<SalonHome />} />
              <Route path='/Salon/:shopSlug/Gallery' element={<Gallery />} />
              <Route path='/Salon/:shopSlug/Services' element={<Services />} />
              <Route path='/Salon/:shopSlug/Team' element={<SalonTeam />} />
              <Route path='/Salon/:shopSlug/Team/Add' element={<AddMembers />} />
              <Route path='/Salon/:shopSlug/details' element={<BusinessDetails />} />
              <Route path='/Salon/:shopSlug/Reviews' element={<Reviews />} />
              <Route path='/Admin/Dashboard' element={<Dashboard />} />
              <Route path='/Admin/Clients' element={<Client />} />
              <Route path='/Salon/Options' element={<Options />} />
              <Route path='/Admin/Team' element={<Team />} />
              <Route path='/Admin/User' element={<User />} />
              <Route path='/Admin/Pages' element={<Pages />} />
              <Route path='/Admin/Signin' element={<Signin />} />
              <Route path='/Admin/Categories' element={<Categoties />} />
              <Route path='/Support' element={<Support />} />
              <Route path='/Admin/ContactRequests' element={<ContactRequests />} />
              <Route path='/Admin/Settings' element={<Settings />} />
              <Route path='/Test' element={<Test />} />
              <Route path='/Service' element={<Service />} />

              {/* <Route path='/Admin/Dashboard' element={<Dashboard />} /> */}
            </Routes>
          </Router>
      </SalonContextProvider>
    </>
  );
}

export default App;
